module.exports = __webpack_public_path__ + "canny-github-integration-504a320954a278d23ee352d14a237a7e.webp";